import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/lib/form/Form";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetDataOnScroll } from "../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import i18n from "i18next";
import { EntOrganicproducers } from "../../../../models/organic/organicProducers";
import { EntOrganicproducersFilter } from "../../../../models/filters/organicProducers";
import { useLazyGetOrganicproducersListQuery } from "../../../../redux/api/organic/organicproducers";
import { EmptyData } from "../../../../components/empty/emptyData";
import { PageHeader } from "../../../../components/page-header";
import { ContentPartFilter } from "../../../../components/content-part/ContentPartFilter";
import { FilterOrganicproducers } from "./FilterOrganicproducers";
import { AddOrganicproducers } from "./AddOrganicproducers";
import { useOrganicproducers } from "./useOrganicproducers";
import _ from "lodash";

enum FormField {
  name,
  legalFormId,
  regionId,
  areaId,
  territorialUnitId,
  registrationDate,
  certificationBody,
  certificationNumber,
  validUntil,
  statusId,
  year,
  animalTypeId,
  productTypeId
}

export const Organicproducers = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [selectedItem, setSelectedItem] = useState<EntOrganicproducers>(new EntOrganicproducers());
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showReportModal, setShowReportModal] = useState<boolean>(false);
  const [form] = useForm();
  const { t } = useTranslation()

  const [getArchiveFolders] = useLazyGetOrganicproducersListQuery();
  const {
	filter,
	fetching,
	data,
	access,
	totalItems,
	setData,
	setFetching,
	setFilter,
	scrollHandler,
	setCurrentPage
  } = useGetDataOnScroll<EntOrganicproducers, EntOrganicproducersFilter>({
	initialFilter: new EntOrganicproducersFilter(),
	query: getArchiveFolders
  });

  const {
    onAddOrganicproducers,
    onDeleteOrganicproducers,
    onEditOrganicproducers
  } = useOrganicproducers(modal, () => {
	searchHandleClick();
  })
  const [height, setHeight] = useState<number>(0);

  const storedData = JSON.parse(localStorage.getItem("availableRoutes") || "[]");
  const isReportAvailable = storedData.some((route: any) => (route.alias === "/report" || route.alias === "/interactive-map-ws") && route.methodPost);

  const openAddModal = (item: EntOrganicproducers) => {
	setSelectedItem(item);
	setShowModal(true);
  }

  const setEntityFromFields = (): EntOrganicproducersFilter => {
	let filt: EntOrganicproducersFilter = _.clone(filter);

	filt.name = form.getFieldValue(FormField.name) ?? null;
	filt.legalFormId = form.getFieldValue(FormField.legalFormId) ?? null;
	filt.regionId = form.getFieldValue(FormField.regionId) ?? null;
	filt.areaId = form.getFieldValue(FormField.areaId ?? null);
	filt.territorialUnitId = form.getFieldValue(FormField.territorialUnitId) ?? null;
	filt.registrationDate = form.getFieldValue(FormField.registrationDate) ?? null;
	filt.certificationBody = form.getFieldValue(FormField.certificationBody) ?? null;
	filt.certificationNumber = form.getFieldValue(FormField.certificationNumber) ?? null;
	filt.validUntil = form.getFieldValue(FormField.validUntil) ?? null;
	filt.statusId = form.getFieldValue(FormField.statusId) ?? null;
	filt.year = form.getFieldValue(FormField.year) ?? null;
	filt.animalTypeId = form.getFieldValue(FormField.animalTypeId) ?? null;
	filt.productTypeId = form.getFieldValue(FormField.productTypeId) ?? null;
	filt.page = 1;
	return filt;
  }

  const clearFields = () => {
	form.setFields([
	  { name: FormField.name, value: null },
	  { name: FormField.legalFormId, value: null },
	  { name: FormField.regionId, value: null },
	  { name: FormField.areaId, value: null },
	  { name: FormField.territorialUnitId, value: null },
	  { name: FormField.registrationDate, value: null },
	  { name: FormField.certificationBody, value: null },
	  { name: FormField.certificationNumber, value: null },
	  { name: FormField.validUntil, value: null },
	  { name: FormField.statusId, value: null },
	  { name: FormField.year, value: null },
	  { name: FormField.animalTypeId, value: null },
	  { name: FormField.productTypeId, value: null },
	]);
  }

  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } } onScroll={ scrollHandler }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('Название производителя') }</th>
		  <th>{ t('Юридическая форма') }</th>
		  <th>{ t('Орган сертификации') }</th>
		  <th>{ t('Дата регистрации') }</th>
		  <th>{ t('Количество продукции') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ? (
		  <tr>
			<th colSpan={ 7 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		) : null }
		{ data.length !== 0 ? data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ item.name }</td>
			<td>{ i18n.language === 'ru' ? item.legalForm?.nameRu : item.legalForm?.nameKy }</td>
			<td>{ item.certificationBody }</td>
			<td>{ item.registrationDate }</td>
			<td>{ item.livestockProductions?.[0]?.quantity ? `${item.livestockProductions[0].quantity.toLocaleString()} ${item.livestockProductions[0].unitMeasurement?.nameRu || ''}` : '-' }</td>
			<td>
			  <Flex gap="small">
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button className='btn_edit' onClick={ () => {
					  openAddModal(item)
					} } type="primary" shape="circle" icon={ <EditOutlined/> }/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button className='btn_edit' danger onClick={ () => {
					  onDeleteOrganicproducers(item)
					} } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
				  </Tooltip>
				) }
			  </Flex>
			</td>
		  </tr>
		)) : (
		  <tr>
			<td colSpan={ 7 }>
			  <EmptyData/>
			</td>
		  </tr>
		) }
		</tbody>
	  </table>
	</div>
  );

  return (
	<>
	  <PageHeader
		title={ t('Органические производители') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } } type="secondary">
			{ t('general.records_found') } { totalItems }
		  </Typography.Text>
		}
	  />
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntOrganicproducers())
		} }>
		  { t('general.add') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={ <FilterOrganicproducers
		  onSearch={ searchHandleClick }
		  onReset={ () => {
			clearFields();
			searchHandleClick()
		  } }
		  formField={ FormField }
		  form={ form }
		/> }
		setHeight={ setHeight }
		table={ table }
	  />

	  <AddOrganicproducers
		item={ selectedItem }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedItem.id !== null ? onEditOrganicproducers : onAddOrganicproducers }
	  />
	  { contextHolder }
	</>
  );
}
